import * as React from "react";
import { Modal, Button, Tooltip } from "antd";
import ManageChallanForm from "../Form/ManageChallanForm";
import {
  EditOutlined,

  // CloseOutlined,
  // CheckOutlined,
} from "@ant-design/icons";
import { isMobile } from "react-device-detect";

export const ManageChallanModalContext = React.createContext<{
  setIsModalVisible: (active: boolean) => void;
}>({
  setIsModalVisible: () => true,
});

const ChallanManageModal: React.FC<{ id: number }> = ({ id }) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const showModal = () => setIsModalVisible(true);

  const handleOk = () => setIsModalVisible(false);

  const handleCancel = () => setIsModalVisible(false);

  return (
    <ManageChallanModalContext.Provider value={{ setIsModalVisible }}>
      <Tooltip title="Edit/Update">
        <Button
          onClick={showModal}
          type="primary"
          shape="circle"
          icon={<EditOutlined />}
        />
      </Tooltip>
      <Modal
        width={isMobile ? "100vw" : 1000}
        title="Manage Challan"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <ManageChallanForm id={id} />
      </Modal>
    </ManageChallanModalContext.Provider>
  );
};

export default ChallanManageModal;
